import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import LoadCSSforfirstTime from "../../../../../../CloudStorage/LoadCSSforfirstTime";
import { getMineUmbrallaByProjectID } from "../../../../../../redux/umbrella/action";
import GetRemainDays from "../PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import { useRouteBaseStateContext } from "../../../../../../Context/RouteBaseStateContext";
import { decodeHtml } from "../../../../../../assests/extention/commonfunction";

export default function ChildUmbrellaProjectListing({ umbrellaprojectdetails }) {
  const { setMyorderActiveprojectroute } = useRouteBaseStateContext();
  const path = "Assets/scss/postproject.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();

  const postlistmine = useSelector(({ umbrella: { umbrellapostlistbyid } }) => umbrellapostlistbyid);

  useEffect(() => {
    if (umbrellaprojectdetails?.id) {
      dispatch(getMineUmbrallaByProjectID(umbrellaprojectdetails?.id));
    }
  }, [umbrellaprojectdetails]);

  const deactivatedContests = Array.isArray(postlistmine) ? postlistmine.filter((item) => item.status == 1) : [];
  const activeContests = Array.isArray(postlistmine) ? postlistmine.filter((item) => item.status == 2) : [];
  const completedContests = Array.isArray(postlistmine) ? postlistmine.filter((item) => item.status == 3) : [];

  // State for managing visibility of project categories
  const [visiblePosted, setVisiblePosted] = useState(4);
  const [visibleActive, setVisibleActive] = useState(4);
  const [visibleCompleted, setVisibleCompleted] = useState(4);

  const handleShowMore = (category) => {
    if (category == "posted") {
      setVisiblePosted(visiblePosted + 4);
    } else if (category == "active") {
      setVisibleActive(visibleActive + 4);
    } else if (category == "completed") {
      setVisibleCompleted(visibleCompleted + 4);
    }
  };

  return (
    <>
      <div className="posted-project">
        <h4>Posted Post & Browse Projects (PBP) ({deactivatedContests.length})</h4>
        <div className="recent-post">
          {deactivatedContests.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            deactivatedContests.slice(0, visiblePosted).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5">
                  <h3>{decodeHtml(item.title)}</h3>
                  <div className="post-img">
                    <p>
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message.svg`} alt="" />
                      Message: {item?.chat_count}
                    </p>
                    <p className="deadline-p">
                      {/* <i className="fa fa-clock-o" aria-hidden="true"></i>5 day left */}
                    </p>
                  </div>
                </div>
                <div className="activity col-md-4">
                  <h6>Activity</h6>
                  <div className="post-img">
                    <p>
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/myorders/proposal.svg`} alt="" />
                      Proposal: {item?.proposal_count}
                    </p>
                    <p>
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message.svg`} alt="" />
                      Message: {item?.chat_count}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => navigate(`/${lan}/dashboard/myorders/project/recent/${item.id}`)}
                  className="btn"
                >
                  View details
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`} alt="" />
                </button>
              </div>
            ))
          )}
          {deactivatedContests.length > visiblePosted && (
            <div
              onClick={() => handleShowMore("posted")}
              style={{
                color: '#007bff',
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: '10px',
                fontWeight: 'bold',
              }}
            >
              View More
            </div>
          )}
        </div>

        {/* Active Projects Section */}
        <h4>Active Post & Browse Projects (PBP) ({activeContests.length})</h4>
        <div className="recent-post">
          {activeContests.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            activeContests.slice(0, visibleActive).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5">
                  <h3>{decodeHtml(item.title)}</h3>
                  <GetRemainDays enddate={item?.active_milestone?.ends_on} />
                </div>
                <div className="activity col-md-4">
                  <h6>Active milestone: {item?.active_milestone_count}</h6>
                  <h5>{!item?.active_milestone?.title ? "No Active Milestone" : decodeHtml(item?.active_milestone?.title)}</h5>
                  <GetStatus status={item?.active_milestone?.status} />
                </div>
                <button
                  onClick={() => {
                    navigate(`/${lan}/dashboard/myorders/project/active/${item.id}`);
                    setMyorderActiveprojectroute("");
                  }}
                  className="btn"
                >
                  Review works
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`} alt="" />
                </button>
              </div>
            ))
          )}
          {activeContests.length > visibleActive && (
            <div
              onClick={() => handleShowMore("active")}
              style={{
                color: '#007bff',
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: '10px',
                fontWeight: 'bold',
              }}
            >
              View More
            </div>
          )}
        </div>

        {/* Completed Projects Section */}
        <h4>Completed Post & Browse Projects (PBP) ({completedContests.length})</h4>
        <div className="recent-post">
          {completedContests.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            completedContests.slice(0, visibleCompleted).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5">
                  <h3>{decodeHtml(item.title)}</h3>
                  <GetRemainDays enddate={item?.active_milestone?.ends_on} />
                </div>
                <div className="activity col-md-4">
                  <h6>Active milestone: {item?.active_milestone_count}</h6>
                  <h5>{!item?.active_milestone?.title ? "No Active Milestone" : decodeHtml(item?.active_milestone?.title)}</h5>
                  <GetStatus status={item?.active_milestone?.status} />
                </div>
                <button
                  onClick={() => {
                    navigate(`/${lan}/dashboard/myorders/project/completed/${item.id}`);
                    setMyorderActiveprojectroute("");
                  }}
                  className="btn"
                >
                  Review works
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`} alt="" />
                </button>
              </div>
            ))
          )}
          {completedContests.length > visibleCompleted && (
            <div
              onClick={() => handleShowMore("completed")}
              style={{
                color: '#007bff',
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: '10px',
                fontWeight: 'bold',
              }}
            >
              View More
            </div>
          )}
        </div>
      </div>
    </>
  );
}
